export const CalculationActionTypes = {
    addition: 'addition',
    deduction: 'deduction',
};
